import { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'

import ImgHandshake from 'assets/icons/img-handshake.svg'

interface DialogSignSKPProps extends Omit<DialogProps, 'children'> {
  isLoading?: boolean
  isDeleteSKPEnabled?: boolean
  ekinEligible?: boolean
  onClickConfirm?: () => any
  onClickCancel?: () => any
}

const DialogSignSKP = ({
  isLoading,
  isDeleteSKPEnabled = false,
  onClickConfirm = () => {},
  onClickCancel = () => {},
  ...props
}: DialogSignSKPProps) => {
  const [isChecked, setIsChecked] = useState(false)

  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent
        aria-labelledby="dialog-sign-skp-title"
        aria-describedby="dialog-sign-skp-description"
      >
        <DialogCloseButton data-testid="btn-close" />
        <div className="mt-12 p-6">
          <ImgHandshake width={84} height={84} />
          <Text
            variant="display-sm"
            className="mt-4"
            as="h2"
            id="dialog-sign-skp-title"
          >
            Konfirmasi untuk Sepakati Perencanaan
          </Text>
          <Text
            color="subdued"
            className="mt-4 !text-xl"
            as="p"
            id="dialog-sign-skp-description"
          >
            {isDeleteSKPEnabled
              ? 'Perencanaan akan otomatis dikirim ke E-Kinerja dalam 1x24 jam. Jika ada yang ingin diubah, Anda dapat ulangi Perencanaan dari awal.'
              : `Perencanaan akan otomatis dikirim ke E-Kinerja dalam 1x24 jam.`}
          </Text>

          <div className="mt-4">
            <Checkbox
              checked={isChecked}
              disabled={isLoading}
              onChange={(e) => setIsChecked(e.target.checked)}
            >
              Saya sepakat dengan Perencanaan yang disetujui oleh Kepala
              Sekolah.
            </Checkbox>
          </div>

          <div className="flex gap-5 mt-5">
            <Button
              size="lg"
              color="white"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={() => onClickCancel()}
              data-testid="btn-cancel"
            >
              {isDeleteSKPEnabled ? 'Ulangi dari awal' : 'Cek ulang'}
            </Button>
            <Button
              size="lg"
              className="w-[190px]"
              disabled={isLoading || !isChecked}
              isLoading={isLoading}
              onClick={() => onClickConfirm()}
              data-testid="btn-confirm"
            >
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogSignSKP
